import { render, staticRenderFns } from "./SpecialistList.vue?vue&type=template&id=7b5505e7"
import script from "./SpecialistList.vue?vue&type=script&lang=js"
export * from "./SpecialistList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports